export default __webpack_public_path__ + "static/media/amit@4x.69a7b36b.png";